import type { Category, ProductSizes, Size } from "../../../../gobalType";

const norm = (s: string) => s.toLowerCase().replace(/\s+/g, " ").trim();

/** Một mục: rỗng = “List”/tất cả; hoặc đúng một id */
export function isPlantRowSelected(
  categoryId: number,
  arrchoicePlant: number[],
  _categories: Category[]
): boolean {
  if (arrchoicePlant.length === 0) {
    return categoryId === 0;
  }
  return arrchoicePlant[0] === categoryId;
}

/** Một mục: rỗng = “All sizes”; hoặc đúng một value */
export function isSizeRowSelected(
  sizeValue: string,
  arrchoiceSize: string[],
  _allSize: Size[]
): boolean {
  if (arrchoiceSize.length === 0) {
    return sizeValue === "all";
  }
  return arrchoiceSize[0] === sizeValue;
}

/**
 * `product_sizes` có khớp filter size (URL / meta) — cùng quy tắc với cột AVAILABILITY desktop.
 */
export function productSizeMatchesFilterSelection(
  ps: ProductSizes,
  selectedSizeValuesFromUrl: string[],
  allSize: Size[]
): boolean {
  if (!selectedSizeValuesFromUrl.length) {
    return true;
  }
  const sel = norm(selectedSizeValuesFromUrl[0]);
  const meta = allSize.find((s) => s.value && norm(s.value) === sel);

  const n = norm(ps.name || "");
  const dim = ps.dimension ? norm(ps.dimension) : "";

  const selectedNorms = selectedSizeValuesFromUrl.map(norm);
  if (selectedNorms.some((s) => s && (s === n || (dim && s === dim)))) {
    return true;
  }
  if (n === sel || (dim && dim === sel)) {
    return true;
  }
  if (meta) {
    if (n === norm(meta.name || "")) return true;
    if (n === norm(meta.value || "")) return true;
    if (dim && (dim === norm(meta.name || "") || dim === norm(meta.value || "")))
      return true;
  }
  return false;
}

/** Desktop: chỉ hiện badge size đang chọn trong filter (vd. 7 gal → chỉ 7Gal). */
export function filterProductSizesBySelection(
  availableWithQty: ProductSizes[] | undefined,
  selectedSizeValuesFromUrl: string[],
  allSize: Size[]
): ProductSizes[] {
  if (!availableWithQty?.length) return [];
  if (!selectedSizeValuesFromUrl.length) {
    return [...availableWithQty];
  }
  return availableWithQty.filter((ps) =>
    productSizeMatchesFilterSelection(ps, selectedSizeValuesFromUrl, allSize)
  );
}

/**
 * Filter ghi `Size.value` (URL), sản phẩm có `product_sizes.name` (và đôi khi `dimension`).
 * Không map qua `allSize` + URL thì `selectedSize` luôn undefined → không add được dù qty > 0.
 */
export function findProductSizeForFilter(
  availableWithQty: ProductSizes[] | undefined,
  selectedSizeValuesFromUrl: string[],
  allSize: Size[]
): ProductSizes | undefined {
  if (!selectedSizeValuesFromUrl.length || !availableWithQty?.length) {
    return undefined;
  }
  return availableWithQty.find((ps) =>
    productSizeMatchesFilterSelection(ps, selectedSizeValuesFromUrl, allSize)
  );
}
